export const rateTypes = [
    { label: "FIXED", value: 1 },
    { label: "PER UNIT", value: 2 },
];
export const rangeRows = [
    {
        range_condition: { value: 1, label: "Less Than Equal To" },
        min_value: null,
        max_value: "0",
        rate: "0",
        unit_of_measure_for: null,
    },
    {
        range_condition: { value: 2, label: "In Between Equal To" },
        min_value: "0",
        max_value: "0",
        rate: "0",
        unit_of_measure_for: null,
    },
    {
        range_condition: { value: 3, label: "Greater Than Equal To" },
        min_value: "0",
        max_value: "0",
        rate: "0",
        unit_of_measure_for: null,
    },
];

export const getLabelValue = (value) => {
        switch (value) {
            case 1: return "FH";
            case 2: return "FC";
            case 3: return "BH";
            default: return "Unknown";
        }
    };

export const InvoiceDays = [1,2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30];    

export const getDayLabel = (value) => {
  const day = parseInt(value, 10);
  if (isNaN(day)) return "";
  const suffix =
    day % 10 === 1 && day % 100 !== 11
      ? "st"
      : day % 10 === 2 && day % 100 !== 12
      ? "nd"
      : day % 10 === 3 && day % 100 !== 13
      ? "rd"
      : "th";
  return `${day}${suffix} of Month`;
};